<template>
  <div class="benefits-accordion" v-if="show">
    <div class="panel" :class="{ open: isOpen('vision') }" v-if="banner1">
      <button type="button" class="panel-header" @click="toggle('vision')">
        <div class="panel-left">
          <div class="panel-logo">
            <img :src="banner1?.image_url" alt="vision-logo" />
          </div>
          <div class="panel-title" v-html="banner1?.title"/>
        </div>

        <span class="chev" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M6 9l6 6 6-6" stroke="#6D6F7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>

      <transition name="collapse" >
        <div v-show="isOpen('vision')" class="panel-body">
          <div class="divider"></div>

          <div class="benefits-list">
            <div class="benefit-item" v-for="bn, i in banner1Child" :key="i">
              <img alt="icon" :src="bn?.image_url" class="benefit-icon"/>
              <div class="benefit-content">
                <div v-html="bn?.title"/>
                <div v-html="bn?.description"/>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- PANEL 2 -->
    <div class="panel" :class="{ open: isOpen('channels') }" v-if="banner2">
      <button type="button" class="panel-header" @click="toggle('channels')">
        <div class="panel-left no-logo">
          <div class="panel-title" v-html="banner2?.title"/>
        </div>

        <span class="chev" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M6 9l6 6 6-6" stroke="#6D6F7A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>

      <transition name="collapse">
        <div v-show="isOpen('channels')" class="panel-body">
          <div class="divider"></div>

          <div class="benefits-list">
            <div class="benefit-item" v-for="bn, i in banner2Child" :key="i">
              <img alt="icon" :src="bn?.image_url" class="benefit-icon"/>
              <div class="benefit-content">
                <div v-html="bn?.title"/>
                <div v-html="bn?.description"/>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { bannerCode } from '@/store'

export default {
  name: 'BenefitAccordion',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    single: {
      type: Boolean,
      default: false
    },
    defaultOpen: {
      type: Array,
      default: () => ['vision', 'channels'] //['vision','channels']
    }
  },
  data () {
    return {
      openKeys: new Set(this.defaultOpen),
      banner1: null,
      banner2: null,
    }
  },
  methods: {
    isOpen (key) {
      return this.openKeys.has(key)
    },
    toggle (key) {
      if (this.single) {
        // accordion mode: hanya 1 yang terbuka
        this.openKeys = new Set(this.openKeys.has(key) ? [] : [key])
        return
      }

      const next = new Set(this.openKeys)
      if (next.has(key)) next.delete(key)
      else next.add(key)
      this.openKeys = next
    },

    async getBanner1() {
      try {
        const res = await this.$store.dispatch('getBanners', bannerCode.bnrKtaSideHtml1)
        this.banner1 = res?.data
      } catch (error) {
        this.logger('Error loading job: ', err)
      }
    },

    async getBanner2() {
      try {
        const res = await this.$store.dispatch('getBanners', bannerCode.bnrKtaSideHtml2)
        this.banner2 = res?.data
      } catch (error) {
        this.logger('Error loading job: ', err)

      }
    },

  },
  computed: {
    banner1Child() {
      return JSON.parse(this.banner1?.child)
    },

    banner2Child() {
      return JSON.parse(this.banner2?.child)
    }
  },

  async mounted() {
    await Promise.all([
      this.getBanner1(),
      this.getBanner2()
    ])
  }
}
</script>

<style scoped>
.benefits-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: -18px;
}

.panel {
  background: #fff;
  border: 1px solid #d6dff4;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}

.panel-header {
  width: 100%;
  background: #fff;
  border: 0;
  cursor: pointer;
  padding: 18px 14px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.panel-left {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  align-items: center;
  min-width: 0;
}

.panel-left.no-logo {
  grid-template-columns: 1fr;
}

.panel-logo {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.panel-logo img {
  width: 24px;
  height: 24px;
  display: block;
}

.panel-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
  text-align: left;
}

.chev {
  display: inline-flex;
  transition: transform 200ms ease;
}

.panel.open .chev {
  transform: rotate(180deg);
}

.panel-body {
  padding: 0 14px 14px;
}

.divider {
  height: 1px;
  background: #d6dff4;
  width: 100%;
  margin-bottom: 12px;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.benefit-item {
  display: flex;
  gap: 12px;
}

.benefit-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.benefit-icon img {
  width: 24px;
  height: 24px;
  display: block;
}

.benefit-content h5 {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 4px 0;
}

.benefit-content p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #6D6F7A;
  font-weight: 500;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: max-height 220ms ease, opacity 220ms ease;
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
.collapse-enter-to,
.collapse-leave-from {
  max-height: 1200px;
  opacity: 1;
}
</style>
